import { takeExistingFilterValue } from "./takeExistingFilterValue.js";
const getFilterInitialValue = (key, value, filterGridItem, filterValuesItem) => {
  var _a;
  const filterValues = (_a = filterValuesItem == null ? void 0 : filterValuesItem.data) == null ? void 0 : _a[key];
  if (typeof filterValues === "undefined" || typeof filterGridItem === "undefined") {
    return;
  }
  const resolvedInitialValues = Array.isArray(value) ? value : [value];
  if (!filterValues || !filterGridItem) {
    return;
  }
  const existingFilterValue = takeExistingFilterValue(resolvedInitialValues, filterValues, filterGridItem);
  return existingFilterValue;
};
const getFiltersInitialValues = (initialFilters, filterGridItems, filterValuesItem) => {
  const result = {};
  Object.keys(initialFilters).forEach((key) => {
    const filterGridItem = filterGridItems.find((item) => item.key === key);
    const value = getFilterInitialValue(
      key,
      initialFilters[key],
      filterGridItem,
      filterValuesItem
    );
    if (typeof value !== "undefined") {
      result[key] = value;
    }
  });
  return result;
};
export {
  getFilterInitialValue,
  getFiltersInitialValues
};
